import React from 'react';
import type { FunctionComponent } from 'react';
import { longDateHandler } from '@utils';

interface PastDueStatusProps {
	currentAttempts: number;
	lastSentOnUtc: string;
}

export const PastDueStatus: FunctionComponent<PastDueStatusProps> = ({ currentAttempts, lastSentOnUtc }) => {
	return (
		<div className="account-status-tooltip">
			<p className="account-status-content-row account-status-content-row--bottom-margin">
				<span className="account-status-content-row--bold">Current Attempts:</span> {currentAttempts}
			</p>
			<p className="account-status-content-row account-status-content-row--bold">Last sent on:</p>
			<p className="account-status-content-row ">{longDateHandler(lastSentOnUtc)}</p>
		</div>
	);
};
